import { Link } from "react-router-dom";
import { Our_Product_Bg } from "../../assets";
import Partners from "../main/partners";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import {
  MOTION_OK,
  revealTrigger,
  maskedLineReveal,
  riseFrom,
} from "../../utils/animations";

const trends = [
  {
    number: "01",
    title: "AI-Native Enterprise Analytics",
    description:
      "Built for the shift from dashboards to autonomous intelligence, Data Assistant is a fully autonomous analytics agent that reasons through data: not just a smarter BI tool.",
  },
  {
    number: "02",
    title: "The Explosion of Agentic Applications",
    description:
      "Every enterprise AI copilot and agent requires validated, real-time behavioural context and Pulse provides the infrastructure layer powering this emerging market.",
  },
  {
    number: "03",
    title: "Domain-Specific AI in Quantitative Finance",
    description:
      "General-purpose LLMs fall short in specialised quantitative domains. CORE Alpha is a fine-tuned language model purpose-built for algorithmic strategy evaluation and quantitative research.",
  },
];

export default function Trends() {
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        maskedLineReveal(sectionRef.current.querySelector(".trends-heading"), {
          scrollTrigger: revealTrigger(".trends-heading"),
        });
        riseFrom(".trend-card", {
          y: 48,
          duration: 1,
          stagger: 0.15,
          scrollTrigger: revealTrigger(".trends-cards", "top 75%"),
        });
        riseFrom(".eco-head > *", {
          stagger: 0.12,
          scrollTrigger: revealTrigger(".eco-head"),
        });
        riseFrom(".eco-cta", {
          scrollTrigger: revealTrigger(".eco-cta", "top 90%"),
        });
      });
      return () => mm.revert();
    },
    { scope: sectionRef }
  );

  return (
    <section
      ref={sectionRef}
      className="pt-[48px] md:py-[96px]"
      style={{
        backgroundImage: `url("${Our_Product_Bg}")`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="container space-y-[96px]">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: heading + CTA */}
          <div className="flex-1 w-full">
            <h2
              className="trends-heading text-white font-extrabold text-2xl md:text-3xl lg:text-[44px] lg:leading-[1.15] text-center lg:text-left"
              dangerouslySetInnerHTML={{
                __html:
                  "Three Secular Trends. One Platform Positioned At Their Intersection.",
              }}
            />
          </div>

          {/* Right: numbered trend cards */}
          <div className="trends-cards flex-1 w-full flex flex-col gap-6">
            {trends.map((trend) => (
              <div
                key={trend.number}
                className="trend-card flex items-center gap-5 md:gap-6 bg-[#40406C80] backdrop-blur-sm  p-4 rounded-xl"
              >
                <span className="text-white font-extrabold text-2xl md:text-3xl lg:text-[44px] leading-none shrink-0">
                  {trend.number}
                </span>
                <div className="space-y-1">
                  <h3 className="text-white text-lg md:text-xl font-extrabold leading-tight !mb-0">
                    {trend.title}
                  </h3>
                  <p className="text-[#C0C0C0] text-sm md:text-base">
                    {trend.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="md:hidden flex justify-center lg:justify-start">
            <button className="mt-0 py-3 font-semibold w-[170px] text-center btn-sweep btn-sweep-blue text-white rounded-[100px] gap-2">
              Explore
            </button>
          </div>
        </div>
      </div>

      <section className="container py-[96px] md:pb-0 md:pt-[114px]">
        <div>
          <div className="eco-head space-y-3 mb-8 flex flex-col items-center">
            <span className="text-base bg-[#EFF0F71F] px-3 p-[6px] rounded-[100px] text-white">
              Partner Ecosystem
            </span>
            <h2 className="text-white font-extrabold text-[24px] md:text-[32px] text-center">
              Built with industry-defining technology partners.
            </h2>
            <p className="text-[#C0C0C0] text-sm md:text-base text-center">
              [AI] Analytics Intelligence integrates with the platforms that
              power enterprise data infrastructure worldwide.
            </p>
          </div>
          <Partners />

          <div className="eco-cta flex justify-center items-center mt-8">
            <Link to="/partners">
              <button className="py-3 px-4 md:px-6 min-w-[170px] text-center btn-sweep btn-sweep-blue font-semibold text-white rounded-[100px] gap-2">
                Explore Partnerships
              </button>
            </Link>
          </div>
        </div>
      </section>
    </section>
  );
}
